import React from "react";
import { useRouteMatch } from "react-router";

import withPreloadedStockPageData from "../../../../../../hocs/withPreloadedStockPageData";
import { useStockPageOptional } from "../../../../../../lib/StockPage";
import StockPageHeader from "../../../../common/StockPageHeader";
import StockPageHeaderShimmer from "../../../../common/StockPageHeaderShimmer";

function StockPagePreloadedHeader({ preloadedStockPageData }) {
  const match = useRouteMatch();
  const stockPage = useStockPageOptional();

  const currentTicker = match?.params?.stockId;
  const stockPayload = stockPage?.stock?.data;
  const stockData = stockPayload?.stock;
  const stockLoading = Boolean(stockPage?.stock?.loading);
  const preloadedStockData = preloadedStockPageData?.stock?.data;

  const hasCorrectStockData = stockData?.ticker === currentTicker;
  const hasCorrectPreloadedStockData =
    preloadedStockData?.ticker === currentTicker;

  const loading = !hasCorrectPreloadedStockData && stockLoading;

  if (loading) {
    return <StockPageHeaderShimmer />;
  }

  if (hasCorrectPreloadedStockData) {
    return <StockPageHeader stock={preloadedStockData} />;
  }

  if (hasCorrectStockData) {
    return <StockPageHeader stock={stockData} />;
  }

  return null;
}

export default withPreloadedStockPageData(StockPagePreloadedHeader);
